<template>
  <div>
    <div class="vx-row">
      <div class="vx-col w-full">
        <div>
          <div class="flex mt-2 mb-3">
            <router-link to="/inventory/stocktransfer" class="mr-2">
              <feather-icon icon="ArrowLeftIcon" svgClasses="text-dark" />
            </router-link>
            <h3>{{ $t("inventory.label.CreateMRN") }}</h3>
          </div>
        </div>
      </div>
      <ValidationObserver ref="observer">
        <div class="vx-col w-full">
          <vx-card title no-shadow card-border>
            <div class="vx-row">
              <div class="vx-col w-full lg:w-1/2 md:w-1/2 sm:w-full xs:w-full">
                <vs-input
                  :label="$t('inventory.label.Type')"
                  class="w-full mb-2 font-semibold"
                  v-model="createMrn.type"
                  disabled
                />
              </div>
              <div class="vx-col w-full lg:w-1/2 md:w-1/2 sm:w-full xs:w-full">
                <div class="dropdown-with-label">
                  <small class="date-label"
                    >{{ $t("stockTransfer.label.Requested Date")
                    }}<span class="required"> *</span></small
                  >
                  <ValidationProvider
                    rules="required"
                    v-slot="{ errors }"
                    :name="$t('stockTransfer.label.Requested Date')"
                  >
                    <datepicker
                      v-model="createMrn.requestedDate"
                      :placeholder="$t('placeholder.label.SelectDate')"
                      class="mb-2 font-semibold"
                    />
                    <span class="validate-error" style="color: red">{{
                      errors[0]
                    }}</span>
                  </ValidationProvider>
                </div>
              </div>

              <div class="vx-col w-full lg:w-1/2 md:w-1/2 sm:w-full xs:w-full">
                <div class="dropdown-with-label">
                  <small class="date-label font-semibold"
                    >{{ $t("stockTransfer.label.Requested By")
                    }}<span class="required"> *</span></small
                  >
                  <!-- <vue-simple-suggest
                  v-model="createMrn.requestedBy"
                  value-attribute="id"
                  display-attribute="externalId"
                  :list="getMrnFalseSuggestionList"
                  class="w-full font-semibold"
                  :filter-by-query="true"
                >
                  <div slot="suggestion-item" slot-scope="{ suggestion }">
                    <span @click="changeCollectionfalse(suggestion)"
                      >{{ suggestion.name }} -- {{ suggestion.externalId }}
                    </span>
                  </div>
                </vue-simple-suggest> -->
                  <vue-simple-suggest
                    v-model="loc"
                    :list="locList"
                    @input="testMethod2()"
                    class="w-full font-normal mb-2"
                    :filter-by-query="true"
                  >
                    <div slot="suggestion-item" slot-scope="{ suggestion }">
                      <span @click="changeLoc(suggestion.id)"
                        >{{ suggestion.externalId }} --
                        {{ suggestion.name }}</span
                      >
                    </div>
                  </vue-simple-suggest>
                </div>
              </div>
              <div class="vx-col w-full lg:w-1/2 md:w-1/2 sm:w-full xs:w-full">
                <div class="dropdown-with-label">
                  <small class="date-label font-semibold"
                    >{{ $t("stockTransfer.label.Request From")
                    }}<span class="required"> *</span></small
                  >
                  <!-- <vue-simple-suggest
                  v-model="createMrn.requestFrom"
                  value-attribute="id"
                  display-attribute="externalId"
                  :list="getMrnTrueSuggestionList"
                  class="w-full font-semibold"
                  :filter-by-query="true"
                >
                  <div slot="suggestion-item" slot-scope="{ suggestion }">
                    <span @click="changeCollectionTrue(suggestion)"
                      >{{ suggestion.externalId }} --
                      {{ suggestion.name }}</span
                    >
                  </div>
                </vue-simple-suggest> -->
                  <vue-simple-suggest
                    v-model="loc1"
                    :list="locList"
                    @input="testMethod3()"
                    class="w-full font-normal mb-2"
                    :filter-by-query="true"
                  >
                    <div slot="suggestion-item" slot-scope="{ suggestion }">
                      <span @click="changeLoc1(suggestion.id)"
                        >{{ suggestion.externalId }} --
                        {{ suggestion.name }}</span
                      >
                    </div>
                  </vue-simple-suggest>
                </div>
              </div>
              <div class="vx-col w-full lg:w-1/2 md:w-1/2 sm:w-full xs:w-full">
                <div class="dropdown-with-label">
                  <small class="date-label"
                    >{{ $t("inventory.label.Item") }}<span class="required"> *</span></small
                  >
                  <ValidationProvider
                    rules="required"
                    v-slot="{ errors }"
                    :name="$t('inventory.label.Item')"
                  >
                    <v-select
                      label="item"
                      v-model="selectedItem"
                      :options="itemList"
                      @input="selectedItems(selectedItem)"
                      :placeholder="$t('placeholder.label.SelectOne')"
                      :dir="$vs.rtl ? 'rtl' : 'ltr'"
                      class="mb-2"
                    >
                      <template v-slot:option="option">{{
                        option.item
                      }}</template>
                    </v-select>
                    <span class="validate-error" style="color: red">{{
                      errors[0]
                    }}</span>
                  </ValidationProvider>
                </div>
              </div>
              <div class="vx-col w-full lg:w-1/2 md:w-1/2 sm:w-full xs:w-full">
                <ValidationProvider
                  rules="required"
                  v-slot="{ errors }"
                  :name="$t('stockTransfer.label.Ordered Quantity')"
                >
                  <vs-input
                    :label="$t('stockTransfer.label.Ordered Quantity')"
                    class="w-full mb-2 starlabel font-semibold"
                    v-model="createMrn.orderdQuantity"
                  />
                  <span class="validate-error" style="color: red">{{
                    errors[0]
                  }}</span>
                </ValidationProvider>
              </div>
              <div class="vx-col w-full lg:w-1/2 md:w-1/2 sm:w-full xs:w-full">
                <div class="dropdown-with-label">
                  <small class="date-label"
                    >{{ $t("inventory.label.Notes") }} <span class="required"> *</span></small
                  >
                  <ValidationProvider
                    rules="required"
                    v-slot="{ errors }"
                    :name="$t('inventory.label.Notes')"
                  >
                    <vs-textarea v-model="createMrn.notes" />
                    <span class="validate-error" style="color: red">{{
                      errors[0]
                    }}</span>
                  </ValidationProvider>
                </div>
              </div>
            </div>
          </vx-card>
        </div>
        <div class="vx-col w-full">
          <div class="saveCancelBtn mb-3">
            <vs-button type="border" class="" @click="resetForm"
              >{{ $t("inventory.label.Reset") }}
            </vs-button>
            <vs-button :disabled="!loc || !loc1" @click="CreateMrvBtn">{{
              $t("inventory.label.Submit")
            }}</vs-button>
          </div>
        </div>
      </ValidationObserver>
    </div>
    <validation-popup
      :errorMessage="errorMessage"
      :warningPopup="warningPopup"
      :warningText="warningText"
      @closeWarning="warningPopup = false"
    ></validation-popup>
  </div>
</template>
<script>
import VueSimpleSuggest from "vue-simple-suggest";
import "vue-simple-suggest/dist/styles.css";
import Datepicker from "vuejs-datepicker";
import vSelect from "vue-select";
import moment from "moment";
import { mapState } from "vuex";
import {
  getMrnTemplate,
  getMrnFalse,
  getMrnTrue,
  postMrn,
} from "@/http/inventory";
import { ValidationObserver, ValidationProvider } from "vee-validate";
const createMrnEmptyObj = {
  type: "mrn",
  requestedDate: moment().format("DD MMMM YYYY"),
  requestedBy: "",
  requestFrom: "",
  itemDescription: "",
  orderdQuantity: "",
  notes: "",
  fromOffice: 0,
  toOffice: 0,
};
export default {
  data() {
    return {
      createMrn: createMrnEmptyObj,
      createMrnPayload: {},
      mrnTemplate: {},
      dateFormat: "dd MMMM yyyy",
      itemList: [],
      selectedItem: "",
      warningPopup: false,
      warningText: "",
      errorMessage: "",
      loc: "",
      loc1: "",
      entity: {
        officeId: "",
        toofficeId: "",
      },
    };
  },
  components: {
    Datepicker,
    "v-select": vSelect,
    VueSimpleSuggest,
    moment,
    ValidationProvider,
    ValidationObserver,
  },
  computed: {
    ...mapState({
      locList: (state) => state.entity.locationList,
    }),
  },

  methods: {
    testMethod2() {
      let temp = this.loc;
      if (temp.includes("{")) {
        temp = JSON.parse(temp);

        if (typeof temp === "object") {
          this.loc = temp.externalId + "--" + temp.name;
          this.entity.officeId = temp.id;
        }
      } else {
        this.$store.dispatch("entity/entityGetLocationAction", this.loc);
      }
    },
    testMethod3() {
      let temp = this.loc1;
      if (temp.includes("{")) {
        temp = JSON.parse(temp);

        if (typeof temp === "object") {
          this.loc1 = temp.externalId + "--" + temp.name;
          this.entity.toofficeId = temp.id;
        }
      } else {
        this.$store.dispatch("entity/entityGetLocationAction", this.loc1);
      }
    },
    async getMrnTemplate() {
      try {
        const resp = await getMrnTemplate();
        this.mrnTemplate = resp.data;
      } catch (e) {
        if (e.httpStatusCode) {
          this.errorMessage = e.errors[0].defaultUserMessage;
        }
      }
    },
    async getMrnFalseSuggestionList() {
      try {
        const response = await getMrnFalse(this.createMrn.requestedBy);
        return response.data.officeData;
      } catch (e) {
        console.log(
          "something went to wrong while retrieving client entity code :",
          e
        );
      }
    },
    async getMrnTrueSuggestionList() {
      try {
        const response = await getMrnTrue(this.createMrn.requestFrom);
        return response.data.officeData;
      } catch (e) {
        console.log(
          "something went to wrong while retrieving client entity code :",
          e
        );
      }
    },
    selectedItems(off) {
      this.mrnTemplate.itemMasterData.map((e) => {
        if (e.id + " -- " + e.itemCode == off) {
          this.createMrn.itemDescription = e.id;
        }
      });
    },
    changeCollectionfalse(e) {
      this.createMrn.fromOffice = e.id;
    },
    changeCollectionTrue(e) {
      this.createMrn.toOffice = e.id;
    },

    backToGoods() {
      this.$router.push("/inventory/stocktransfer");
    },
    async CreateMrvBtn() {
      const isValid = await this.$refs.observer.validate();
      if (!isValid) return;
      this.createMrnPayload.dateFormat = this.dateFormat;
      this.createMrnPayload.toOffice = this.entity.officeId;
      this.createMrnPayload.itemDescription = this.createMrn.itemDescription;
      this.createMrnPayload.locale = "en";
      this.createMrnPayload.notes = this.createMrn.notes;
      this.createMrnPayload.orderdQuantity = this.createMrn.orderdQuantity;
      this.createMrnPayload.requestedDate = moment(
        this.createMrn.requestedDate
      ).format("DD MMMM YYYY");
      this.createMrnPayload.requestedTime = moment(this.requestedTime).format(
        " h:mm:ss a"
      );
      this.createMrnPayload.fromOffice = this.entity.toofficeId;
      this.createMrnPayload.type = this.createMrn.type;
      try {
        const resp = await postMrn(this.createMrnPayload);
        this.$swal({
          title: "Success",
          icon: "success",
          text: "MRN Created Successfully!",
          type: "success",
        });
        if (resp.data.resourceId) {
          this.$router.push("/inventory/stocktransfer");
          this.resetForm();
        }
      } catch (e) {
        if (e.httpStatusCode) {
          this.errorMessage = e.errors[0].defaultUserMessage;
        }
        console.log("something went to wrong while creating entity:", e);
      }
    },
    resetForm() {
      this.createMrn = { ...createMrnEmptyObj };
      this.createMrn.requestedDate = moment().format("DD MMMM YYYY");
      this.createMrn.requestedBy = "";
      this.createMrn.requestFrom = "";
      this.createMrn.itemDescription = "";
      this.createMrn.orderdQuantity = "";
      this.createMrn.notes = "";
      this.loc = "";
      this.loc1 = "";
      this.selectedItem = "";
    },
  },
  watch: {
    mrnTemplate(val) {
      for (let role of val.itemMasterData) {
        this.itemList.push(role.id + " -- " + role.itemCode);
      }
    },
  },

  mounted() {
    this.getMrnTemplate();
  },
};
</script>
<style scoped></style>
